export default {"src":"/_next/static/media/goals.e2b5e2e1.svg","height":33,"width":34,"blurWidth":0,"blurHeight":0};